/* eslint-disable no-console */
import { objectToQueryString } from 'Utils/utils'
import AxiosClient from './api'
import END_POINT from './constants'

export function getUserList(payload) {
  const params = objectToQueryString(payload)
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.ACCOUNT_INFO.GET}${params}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function inviteEmail(payload) {
  return new Promise((resolve, reject) => {
    AxiosClient.post(`${END_POINT.ACCOUNT_INFO.INVITE_EMAIL}/${encodeURIComponent(payload?.email)}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function postAcceptedInviteMember(payload) {
  return new Promise((resolve, reject) => {
    AxiosClient.post(`${END_POINT.ACCOUNT_INFO.ACCEPT_INVITE_MEMBER}`, payload)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function changeEmail(payload) {
  return new Promise((resolve, reject) => {
    AxiosClient.post(`${END_POINT.ACCOUNT_INFO.CHANGE_EMAIL}`, payload)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function verifyChangeEmail(payload) {
  return new Promise((resolve, reject) => {
    AxiosClient.put(`${END_POINT.ACCOUNT_INFO.VERIFY_CHANGE_EMAIL}/${payload.oldEmail}/${payload.code}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function deleteAccount(payload) {
  return new Promise((resolve, reject) => {
    AxiosClient.delete(`${END_POINT.ACCOUNT_INFO.DELETE_ACCOUNT}/${payload.id}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}
